<form [formGroup]="priceForm" (ngSubmit)="onSubmit()">
    <ng-container formArrayName="pricedetail">
      <div *ngFor="let detail of pricedetail.controls; let i = index" [formGroup]="detail">
        <div fxLayout.xs="column" fxLayout="row">
            <div fxFlex.xs="100" fxFlex="70">
                <mat-form-field fxFlex>
                    <mat-label>Title</mat-label>
                    <input [attr.guide]="'price-table-plan4-inp-title' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title" />
                </mat-form-field>
            </div>
            <div fxFlex.xs="100" fxFlex="30">
                <button [attr.guide]="'price-table-plan4-btn-1' + '__' + sanitizeUrl(url)" mat-raised-button color="warn" (click)="deletePricingDetail(i)">Delete</button>
            </div>
        </div>
        <ng-container formArrayName="list_detail">
          <div *ngFor="let item of detail.get('list_detail').controls; let j = index" [formGroup]="item" style="border: 1px solid lightgray;padding: 15px;margin: 5px;">
            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10px">
                <mat-form-field fxFlex>
                    <mat-label>Sub Title</mat-label>
                    <input [attr.guide]="'price-table-plan4-inp-sub-title' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="sub_title" />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label>Sub Title1</mat-label>
                    <input [attr.guide]="'price-table-plan4-inp-sub-title1' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="sub_title1" />
                </mat-form-field>
            </div>
            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10px">
                <mat-form-field fxFlex>
                    <mat-label>Sub Title2</mat-label>
                    <input [attr.guide]="'price-table-plan4-inp-sub-title2' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="sub_title2" />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label>Sub Title3</mat-label>
                    <input [attr.guide]="'price-table-plan4-inp-sub-title3' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="sub_title3" />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label>Sub Title4</mat-label>
                    <input [attr.guide]="'price-table-plan4-inp-sub-title4' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="sub_title4" />
                </mat-form-field>
            </div>
            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10px">
                <mat-form-field fxFlex>
                    <mat-label>Sub Title5</mat-label>
                    <input [attr.guide]="'price-table-plan4-inp-sub-title5' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="sub_title5" />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label>Sub Title6</mat-label>
                    <input [attr.guide]="'price-table-plan4-inp-sub-title6' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="sub_title6" />
                </mat-form-field>
                <div fxFlex>
                    <button [attr.guide]="'price-table-plan4-btn-2' + '__' + sanitizeUrl(url)" mat-raised-button color="warn" (click)="deleteListDetail(i, j)">Delete</button>
                </div>
            </div>

          </div><br/>
          <button [attr.guide]="'price-table-plan4-btn-3' + '__' + sanitizeUrl(url)" mat-raised-button (click)="addListDetail(i)">Add List Detail</button>
        </ng-container><br/>
      </div><br/>
      <button [attr.guide]="'price-table-plan4-btn-4' + '__' + sanitizeUrl(url)" mat-raised-button (click)="addPricingDetails()">Add Pricing Detail</button>
    </ng-container><br/>
    <button [attr.guide]="'price-table-plan4-btn-5' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" type="submit" style="margin-top: 10px;margin-bottom: 10px;" >{{btntext}}</button>
  </form>
